import { getAxiosConfigUserToken, openPDFFile } from "app/utils/appHelpers";
import axios from "axios";
import config from "config";


export const getReportSubjectGroups = async (filters) => {
    try {


        const modifiedStartedDate = (filters.startedDate === "1970-01-01 00:00:01") ? undefined : filters.startedDate;
        const modifiedFinishedDate = (filters.finishedDate === "1970-01-01 23:59:59") ? undefined : filters.finishedDate;

        const response = await axios.get(`${config.apiUrl}/v1/report/getReportSubjectGroups`, {
            params: {
                inst: filters.inst || undefined,
                unit: filters.unit || undefined,
                startedDate: modifiedStartedDate,
                finishedDate: modifiedFinishedDate
            },
            ...getAxiosConfigUserToken()
        });
        return response;
    } catch (error) {
        console.error("Error fetching report subject groups:", error);
        throw error;
    }
};
export const generateSubjectGroupsPDFAPI = async (filters) => {
    try {
        const modifiedStartedDate = (filters.startedDate === "1970-01-01 00:00:01") ? undefined : filters.startedDate;
        const modifiedFinishedDate = (filters.finishedDate === "1970-01-01 23:59:59") ? undefined : filters.finishedDate;

        const url = `${config.apiUrl}/v1/report/getReportSubjectGroupsPDF`;
        const response = await axios.get(url, {
            params: {
                inst: filters.inst || undefined,
                unit: filters.unit || undefined,
                startedDate: modifiedStartedDate,
                finishedDate: modifiedFinishedDate,
            },
            responseType: 'blob',  // PDF dosyası olarak al
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/pdf' });
        return openPDFFile(file);
    } catch (error) {
        console.error("Error fetching report subject groups:", error);
        throw error;
    }
};

export const generateDecisionCountInfoPDFAPI = async (inst, unitId, meetingNo, userId) => {
    try {

        const url = `${config.apiUrl}/v1/report/getReportDecisionCountInfoPDF`;
        const response = await axios.get(url, {
            params: {
                inst: inst || undefined,
                unitId: unitId || undefined,
                meetingNo: meetingNo || undefined,
                userId: userId || undefined,
            },
            responseType: 'blob',  // PDF dosyası olarak al
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/pdf' });
        return openPDFFile(file);
    } catch (error) {
        console.error("Error fetching report subject groups:", error);
        throw error;
    }
};

export const getAttendanceMeetingUsersPDFAPI = async (inst, unitId, meetingNo, type, attendanceStatus, userId) => {
    try {

        const url = `${config.apiUrl}/v1/report/getReportAttendanceUsersPDF`;
        const response = await axios.get(url, {
            params: {
                inst: inst || undefined,
                unitId: unitId || undefined,
                meetingNo: meetingNo || undefined,
                type: type || undefined,
                attendanceStatus: attendanceStatus || undefined,
                userId: userId || undefined,
            },
            responseType: 'blob',
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/pdf' });
        return openPDFFile(file);
    } catch (error) {
        console.error("Error fetching report subject groups:", error);
        throw error;
    }
};

export const getAttendanceMeetingUsersByFilter = async (params) => {
    const url = `${config.apiUrl}/v1/report/getAttendanceMeetingUsersByFilter/`;
    return await axios.get(url, {
        ...getAxiosConfigUserToken(),
        params
    }).then(response => response.data);
}


export const getReportUnitCountApi = async (filters) => {
    try {
        const modifiedStartedDate = (filters.startedDate === "1970-01-01 00:00:01") ? undefined : filters.startedDate;
        const modifiedFinishedDate = (filters.finishedDate === "1970-01-01 23:59:59") ? undefined : filters.finishedDate;

        const response = await axios.post(`${config.apiUrl}/v1/report/postReportUnitCount`, {
            inst: filters.inst || undefined,
            startedDate: modifiedStartedDate,
            finishedDate: modifiedFinishedDate,
            showWithDates: filters.showWithDates || undefined
        }, {
            ...getAxiosConfigUserToken()
        });
        return response;
    } catch (error) {
        console.error("Error fetching report unit count:", error);
        throw error;
    }
};
export const generateUnitCountPDFApi = async (filters) => {
    try {
        const modifiedStartedDate = (filters.startedDate === "1970-01-01 00:00:01") ? undefined : filters.startedDate;
        const modifiedFinishedDate = (filters.finishedDate === "1970-01-01 23:59:59") ? undefined : filters.finishedDate;

        const url = `${config.apiUrl}/v1/report/postReportUnitCountPDF`;
        const response = await axios.post(url, {
            inst: filters.inst || undefined,
            startedDate: modifiedStartedDate,
            finishedDate: modifiedFinishedDate,
            showWithDates: filters.showWithDates || undefined
        }, {
            responseType: 'blob',
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/pdf' });
        return openPDFFile(file);
    } catch (error) {
        console.error("Error generating unit count PDF:", error);
        throw error;
    }
};

export const getReportBoardMemberMeetingsApi = async (filters) => {
    try {
        const modifiedStartedDate = (filters.startedDate === "1970-01-01 00:00:01") ? undefined : filters.startedDate;
        const modifiedFinishedDate = (filters.finishedDate === "1970-01-01 23:59:59") ? undefined : filters.finishedDate;

        const response = await axios.post(`${config.apiUrl}/v1/report/postReportBoardMemberMeetings`, {
            userId: filters.userId || undefined,
            attendanceStatus: filters.attendanceStatus || undefined,
            startedDate: modifiedStartedDate,
            finishedDate: modifiedFinishedDate
        }, {
            ...getAxiosConfigUserToken()
        });
        return response;
    } catch (error) {
        console.error("Error fetching board member meetings report:", error);
        throw error;
    }
};

export const generateBoardMemberMeetingsPDFApi = async (filters) => {
    try {
        const modifiedStartedDate = (filters.startedDate === "1970-01-01 00:00:01") ? undefined : filters.startedDate;
        const modifiedFinishedDate = (filters.finishedDate === "1970-01-01 23:59:59") ? undefined : filters.finishedDate;

        const url = `${config.apiUrl}/v1/report/postReportBoardMemberMeetingsPDF`;
        const response = await axios.post(url, {
            userId: filters.userId || undefined,
            attendanceStatus: filters.attendanceStatus || undefined,
            startedDate: modifiedStartedDate,
            finishedDate: modifiedFinishedDate,
        }, {
            responseType: 'blob',  // PDF dosyası olarak al
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/pdf' });
        return openPDFFile(file);
    } catch (error) {
        console.error("Error generating board member meetings PDF:", error);
        throw error;
    }
};

export const getReportAuthorityListApi = async (filters) => {
    try {
        const response = await axios.post(`${config.apiUrl}/v1/report/postReportAuthorityList`, {
            instIds: filters.instIds || undefined,
        }, {
            ...getAxiosConfigUserToken()
        });
        return response;
    } catch (error) {
        console.error("Error fetching authority list report:", error);
        throw error;
    }
};

export const generateReportAuthorityListPDFApi = async (filters) => {
    try {
        const url = `${config.apiUrl}/v1/report/postReportAuthorityListPDF`;
        const response = await axios.post(url, {
            instIds: filters.instIds || undefined,
        }, {
            responseType: 'blob',  // PDF dosyası olarak al
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/pdf' });
        return openPDFFile(file);
    } catch (error) {
        console.error("Error generating authority list PDF:", error);
        throw error;
    }
};

// YKK Raporu - Yönetim Kurulu Kararları Uygulanma Durumları - Veri çekme
export const getYKKReportDataApi = async (filters) => {
    try {
        const url = `${config.apiUrl}/v1/report/postYKKReportData`;
        const response = await axios.post(url, filters, {
            ...getAxiosConfigUserToken()
        });
        return response;
    } catch (error) {
        console.error("Error fetching YKK report data:", error);
        throw error;
    }
};

// YKK Raporu - PDF
export const generateYKKReportPDFApi = async (filters) => {
    try {
        const url = `${config.apiUrl}/v1/report/postYKKReportPDF`;
        const response = await axios.post(url, filters, {
            responseType: 'blob',
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/pdf' });
        return openPDFFile(file);
    } catch (error) {
        console.error("Error generating YKK report PDF:", error);
        throw error;
    }
};

// YKK Raporu - Word
export const generateYKKReportWORDApi = async (filters, fileName = "YKK_Rapor") => {
    try {
        const url = `${config.apiUrl}/v1/report/postYKKReportWORD`;
        const response = await axios.post(url, filters, {
            responseType: 'blob',
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/octet-stream' });

        // Word dosyası indirme
        const downloadUrl = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `${fileName}.docx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        return true;
    } catch (error) {
        console.error("Error generating YKK report Word:", error);
        throw error;
    }
};

// Decisions Raporu - Kararlar - Veri çekme
export const getDecisionsReportDataApi = async (filters) => {
    try {
        const url = `${config.apiUrl}/v1/report/postDecisionsReportData`;
        console.log('filters', filters);
        const response = await axios.post(url, filters, {
            ...getAxiosConfigUserToken()
        });
        return response;
    } catch (error) {
        console.error("Error fetching Decisions report data:", error);
        throw error;
    }
};

// Decisions Raporu - PDF
export const generateDecisionsReportPDFApi = async (filters) => {
    try {
        const url = `${config.apiUrl}/v1/report/postDecisionsReportPDF`;
        const response = await axios.post(url, filters, {
            responseType: 'blob',
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/pdf' });
        return openPDFFile(file);
    } catch (error) {
        console.error("Error generating Decisions report PDF:", error);
        throw error;
    }
};

export const generateDecisionsReportWORDApi = async (filters, fileName = "Kararlar_Rapor") => {
    try {
        const url = `${config.apiUrl}/v1/report/postDecisionsReportWORD`;
        const response = await axios.post(url, filters, {
            responseType: 'blob',
            ...getAxiosConfigUserToken()
        });

        const file = new Blob([response.data], { type: 'application/octet-stream' });

        const downloadUrl = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `${fileName}.docx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        return true;
    } catch (error) {
        console.error("Error generating Decisions report Word:", error);
        throw error;
    }
};